
import Button from '@/components/UntitledUI/Button.vue'
import Icon from '@/components/UntitledUI/Icon.vue'

export default {
    components: { Button, Icon },
    props: {
        item: Object,
        highlightsColors: Object,
        loading: Boolean
    },
    data () {
        return {
            form: new this.$vForm({}),
            showRemoveConfirm: false
        }
    },
    methods: {
        async removeItem () {
            try {
                await this.form.delete('/v1/highlights/' + this.item.id)
            } catch (e) {
                return
            }
            this.$emit('item-deleted', this.item.id)
        }
    }
}
